<!--
 * @Author: your name
 * @Date: 2021-09-27 17:48:35
 * @LastEditTime: 2022-11-15 16:35:28
 * @LastEditors: LAPTOP-JM4BAR46
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\src\views\center-business\strategy\logistics\orderMoney\components\DataForm.vue
-->
<template>
  <BjDrawerForm
    ref="BjDrawerForm"
    :form="form"
    :rules="rules"
    label-width="120px"
    @handleConfirm="handleConfirm"
  >
    <el-col :span="span">
      <el-form-item :label="$t('settingZones.dialog.province')" prop="provinceId">
        <BjSelectChinaArea
          v-model="form.provinceId"
          all
          class="full-width"
          @change="changeProvince"
        />
      </el-form-item>
      <el-form-item v-show="form.provinceId !== 0" :label="$t('settingZones.dialog.city')" prop="cityId">
        <BjSelectChinaArea
          v-model="form.cityId"
          type="city"
          all
          :disabled="form.provinceId === null || form.provinceId === 0"
          :parent-code="form.provinceId"
          class="full-width"
          @change="changeCity"
        />
      </el-form-item>
      <el-form-item v-show="form.cityId !== 0 || form.areaId !== 0" :label="$t('settingZones.dialog.district')" prop="areaName">
        <BjSelectChinaArea
          v-model="form.areaId"
          type="area"
          all
          :disabled="form.cityId === null || form.cityId === 0"
          :parent-code="form.cityId"
          class="full-width"
          @change="changeArea"
        />
      </el-form-item>
    </el-col>
    <el-col :span="span">
      <el-form-item :label="$t('settingZones.dialog.logistics')" prop="logisticCompanyId">
        <BjSelectLogisticCompany
          :value="form.logisticCompanyId"
          :default-options="{
            label: form.logisticCompanyName,
            value: form.logisticCompanyId,
          }"
          @change="onLogistic"
        />
      </el-form-item>
    </el-col>
    <el-col :span="span">
      <el-form-item :label="$t('settingZones.dialog.business')" prop="logisticBusinessId">
        <BjSelectLogisticBusiness
          :value="form.logisticBusinessId"
          :disabled="!form.logisticCompanyId"
          :default-params="defaultParams"
          :default-options="{
            label: form.logisticBusinessName,
            value: form.logisticBusinessId,
          }"
          :placeholder="form.logisticCompanyId ? $t('chooseText') : $t('settingZones.dialog.selectLogisticsValid')"
          @change="onBusiness"
        />
      </el-form-item>
    </el-col>
  </BjDrawerForm>
</template>
<script>
import { settingApi } from '@/api';
export default {
  props: {
    disabledList: {
      type: Object,
      default: () => {
        return {
          provinceIds: [],
          cityIds: [],
          areaIds: [],
        };
      },
    },
  },
  data() {
    return {
      span: 22,
      // 表单参数
      isEdit: false,
      form: {
        provinceId: 0,
        provinceName: this.$t('wholeText'),
        cityId: 0,
        cityName: this.$t('wholeText'),
        areaId: 0,
        areaName: this.$t('wholeText'),
        logisticCompanyId: null,
        logisticCompanyNo: null,
        logisticCompanyName: null,
        logisticBusinessId: null,
        logisticBusinessNo: null,
        logisticBusinessName: null,
        orderNum: 1,
        enabledFlag: true,
      },
      cloneFrom: {
        provinceId: 0,
        provinceName: this.$t('wholeText'),
        cityId: 0,
        cityName: this.$t('wholeText'),
        areaId: 0,
        areaName: this.$t('wholeText'),
        logisticCompanyId: null,
        logisticCompanyNo: null,
        logisticCompanyName: null,
        logisticBusinessId: null,
        logisticBusinessNo: null,
        logisticBusinessName: null,
        orderNum: 1,
        enabledFlag: true,
      }
    };
  },
  computed: {
    rules() {
      // 表单校验
      const rules = {
          provinceId: [{ required: true, message: this.$t('settingZones.dialog.selectProvince'), trigger: 'change' }],
          cityId: [{ required: true, message: this.$t('settingZones.dialog.urbanArea'), trigger: 'change' }],
          areaId: [{ required: true, message: this.$t('settingZones.dialog.area'), trigger: 'change' }],
          logisticCompanyId: [{ required: true, message: this.$t('settingZones.dialog.selectLogistics'), trigger: 'change' }],
          logisticBusinessId: [{ required: true, message: this.$t('settingZones.dialog.selectBusiness'), trigger: 'change' }],
        };
      return rules;
    },
    defaultParams() {
      // 以 所属物流商 为默认参数
      return { companyId: this.form.logisticCompanyId, enableFlag: true };
    },
  },
  watch: {},
  mounted() {},
  methods: {
    show(info) {
      this.isEdit = !!info;
      this.$refs.BjDrawerForm.show();
      this.$refs.BjDrawerForm.setTitle(this.isEdit ? this.$t('settingZones.dialog.editTitle') : this.$t('settingZones.dialog.addTitle'));
      // if (this.isEdit) this.getData(info.id);
      this.form = Object.assign(this.cloneFrom, info || {});
    },
    changeProvince(val, item) {
      this.form.provinceId = item.areaCode;
      this.form.provinceName = item.name;
      this.form.cityId = this.form.areaId = 0;
      this.form.cityName = this.form.areaName = this.$t('wholeText');
      if (!val) {
        this.form.cityId = this.form.areaId = 0;
        this.form.cityName = this.form.areaName = this.$t('wholeText');
      }
      if (val === 0) {
        this.form.cityId = this.form.areaId = 0;
        this.form.cityName = this.form.areaName = this.$t('wholeText');
      }
    },
    changeCity(val, item) {
      this.form.cityName = item.name;
      this.form.cityId = item.areaCode;
      this.form.areaId = 0;
      this.form.areaName = this.$t('wholeText');
      if (!val) this.form.areaId = 0;
      if (val === 0) {
        this.form.areaId = 0;
        this.form.areaName = this.$t('wholeText');
      }
    },
    changeArea(val, item) {
      this.form.areaId = item.areaCode;
      this.form.areaName = item.name;
    },
    onLogistic(val, data = {}) {
      this.form.logisticCompanyId = data.id;
      this.form.logisticCompanyNo = data.code;
      this.form.logisticCompanyName = data.name;

      this.form.logisticBusinessId = null;
      this.form.logisticBusinessNo = null;
      this.form.logisticBusinessName = null;
    },
    onBusiness(val, data = {}) {
      this.form.logisticBusinessId = data.id;
      this.form.logisticBusinessNo = data.code;
      this.form.logisticBusinessName = data.name;
    },
    handleConfirm() {
      const API_DATA = this.$lodash.clone(this.form);
      if (this.isEdit) {
        API_DATA['_innerMap'] = {};
      }
      this.saveApi(API_DATA);
    },
    reFresh() {
      this.$emit('reFresh');
    },
    getData(id) {
      settingApi.getStrategyZonesDetail({ id }).then(res => {
        this.form = res;
      });
    },
    saveApi(API_DATA) {
      if (this.isEdit) {
        settingApi.updateStrategyZones(API_DATA).then(res => {
          if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
            this.$message.success(this.$t('toast.operationSuccessText'));
            setTimeout(() => {
              this.$refs.BjDrawerForm.hide();
              this.reFresh();
            }, 500);
          }
        });
      } else {
        settingApi.addStrategyZones(API_DATA).then(res => {
          if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
            this.$message.success(this.$t('toast.operationSuccessText'));
            setTimeout(() => {
              this.$refs.BjDrawerForm.hide();
              this.reFresh();
            }, 500);
          }
        });
      }
    },
  },
};
</script>
<style scoped>
.el-tag {
  margin: 6px;
}
</style>
